import { call, put } from 'redux-saga/effects';
import DeleteWithdrawalActions from '../redux/DeleteWithdrawalRedux';
import { api } from './api';


export function* deletewithdrawalsagas(action: any): Generator<any, void, any> {
  const { withdrawal_id } = action;
  const response = yield call(api.deleteWithdrawal, withdrawal_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(DeleteWithdrawalActions.deleteWithdrawalSuccess(response.data));
  } else {
    yield put(DeleteWithdrawalActions.deleteWithdrawalFailure());
  }
}